import React from "react";

interface ConferenceBasicInfoProps {
  formData: {
    vietnameseName: string;
    englishName: string;
    type: string;
    budget: string;
    budgetSource: string;
    executionTime: string;
    endTime: string;
    venue: string;
    vietnameseParticipants: string;
    foreignParticipants: string;
    hostUnit: string;
    conferenceChair: string;
    participants: string;
    speakers: string;
    mainContent: string;
    evaluation: string;
  };
  handleInputChange: (field: string, value: string) => void;
}

const ConferenceBasicInfo: React.FC<ConferenceBasicInfoProps> = ({
  formData,
  handleInputChange,
}) => {
  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      {/* Two Column Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Left Column */}
        <div className="space-y-4">
          {/* Tên tiếng Việt (*) */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Tên tiếng Việt <span className="text-red-500">(*)</span>
            </label>
            <input
              type="text"
              value={formData.vietnameseName}
              onChange={(e) =>
                handleInputChange("vietnameseName", e.target.value)
              }
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Tên tiếng Việt..."
            />
          </div>

          {/* Loại (*) */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Loại <span className="text-red-500">(*)</span>
            </label>
            <select
              value={formData.type}
              onChange={(e) => handleInputChange("type", e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">- Loại -</option>
              <option value="conference">Hội nghị</option>
              <option value="workshop">Hội thảo</option>
              <option value="seminar">Seminar</option>
              <option value="symposium">Hội nghị chuyên đề</option>
            </select>
          </div>

          {/* Kinh phí và Nguồn kinh phí */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Kinh phí
              </label>
              <div className="flex">
                <input
                  type="text"
                  value={formData.budget}
                  onChange={(e) => handleInputChange("budget", e.target.value)}
                  className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-l-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Kinh phí..."
                />
                <button
                  type="button"
                  className="px-3 py-2 text-sm bg-gray-200 text-gray-700 border border-l-0 border-gray-300 rounded-r-md hover:bg-gray-300 transition-colors"
                >
                  USD
                </button>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nguồn kinh phí
              </label>
              <select
                value={formData.budgetSource}
                onChange={(e) =>
                  handleInputChange("budgetSource", e.target.value)
                }
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">- Chọn -</option>
                <option value="government">Ngân sách nhà nước</option>
                <option value="international">Tài trợ quốc tế</option>
                <option value="private">Tư nhân</option>
                <option value="mixed">Hỗn hợp</option>
              </select>
            </div>
          </div>

          {/* Địa điểm tổ chức */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Địa điểm tổ chức
            </label>
            <input
              type="text"
              value={formData.venue}
              onChange={(e) => handleInputChange("venue", e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Địa điểm tổ chức..."
            />
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-4">
          {/* Tên tiếng Anh (*) */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Tên tiếng Anh <span className="text-red-500">(*)</span>
            </label>
            <input
              type="text"
              value={formData.englishName}
              onChange={(e) => handleInputChange("englishName", e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="English Name..."
            />
          </div>

          {/* Thời gian thực hiện và đến */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Thời gian thực hiện
              </label>
              <input
                type="date"
                value={formData.executionTime}
                onChange={(e) =>
                  handleInputChange("executionTime", e.target.value)
                }
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                đến
              </label>
              <input
                type="date"
                value={formData.endTime}
                onChange={(e) => handleInputChange("endTime", e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>

          {/* Số lượng người Việt Nam và Số lượng người nước ngoài - 2 cột */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Số lượng người Việt Nam
              </label>
              <input
                type="number"
                value={formData.vietnameseParticipants}
                onChange={(e) =>
                  handleInputChange("vietnameseParticipants", e.target.value)
                }
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Số lượng người Việt Nam..."
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Số lượng người nước ngoài
              </label>
              <input
                type="number"
                value={formData.foreignParticipants}
                onChange={(e) =>
                  handleInputChange("foreignParticipants", e.target.value)
                }
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Số lượng người nước ngoài..."
              />
            </div>
          </div>

          {/* Đơn vị chủ trì và Chủ trì Hội nghị - 2 cột */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Đơn vị chủ trì
              </label>
              <input
                type="text"
                value={formData.hostUnit}
                onChange={(e) => handleInputChange("hostUnit", e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Đơn vị chủ trì..."
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Chủ trì Hội nghị
              </label>
              <input
                type="text"
                value={formData.conferenceChair}
                onChange={(e) =>
                  handleInputChange("conferenceChair", e.target.value)
                }
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Chủ trì Hội nghị..."
              />
            </div>
          </div>
        </div>
      </div>

      {/* Thành phần tham gia và Nội dung chính - 2 cột */}
      <div className="mt-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Thành phần tham gia
            </label>
            <textarea
              value={formData.participants}
              onChange={(e) =>
                handleInputChange("participants", e.target.value)
              }
              rows={4}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
              placeholder="Thành phần tham gia..."
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Nội dung chính
            </label>
            <textarea
              value={formData.mainContent}
              onChange={(e) => handleInputChange("mainContent", e.target.value)}
              rows={4}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
              placeholder="Nội dung chính..."
            />
          </div>
        </div>
      </div>

      {/* Diễn giả - Full Width */}
      <div className="mt-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Diễn giả
        </label>
        <input
          type="text"
          value={formData.speakers}
          onChange={(e) => handleInputChange("speakers", e.target.value)}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="Diễn giả..."
        />
      </div>

      {/* Đánh giá kết quả - Full Width */}
      <div className="mt-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Đánh giá kết quả
        </label>
        <textarea
          value={formData.evaluation}
          onChange={(e) => handleInputChange("evaluation", e.target.value)}
          rows={4}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
          placeholder="Đánh giá kết quả..."
        />
      </div>
    </div>
  );
};

export default ConferenceBasicInfo;
